import { LoadingButton } from "@mui/lab";
import { Box, Button, Grid, Typography, useMediaQuery } from "@mui/material";
import MultyTrayCreateForm from "pages/vending/machine/create/MultyTrayCreateForm";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCabinsByMachineThunk } from "store/reducers/vending";

const TrayCreateInWizardForm = ({
  handleNext,
  handleSkip,
  trayStepCompleted,
  setTrayStepCompleted,
  machine,
  fullGrid = false,
}) => {
  const isFullWidth = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const vendingState = useSelector((state) => state.vending);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getCabinsByMachineThunk(machine.id));
  }, [dispatch, machine]);

  return (
    <Box sx={{ mb: 2 }}>
      {(vendingState.cabins[machine.id]?.length ?? 0) === 0 ? (
        <div>
          <Typography variant="h6" color="gray">
            This step can not be proceeded without cabins
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
              alignItems: "center",
              marginTop: 3,
            }}
          >
            <Grid container columnSpacing={2} rowSpacing={0}>
              <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    alignItems: "center",
                    marginTop: 3,
                  }}
                >
                  {!fullGrid && (
                    <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                      Skip
                    </Button>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </div>
      ) : (
        <>
          {vendingState.cabins[machine.id].map((cabin) => (
            <MultyTrayCreateForm
              marginTop={3}
              key={cabin.id}
              cabin={cabin}
              setTrayStepCompleted={setTrayStepCompleted}
              fullGrid={fullGrid}
            />
          ))}
          <Grid container columnSpacing={2} rowSpacing={0}>
            <Grid item xs={12} md={fullGrid ? 12 : 6} lg={fullGrid ? 12 : 4}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  alignItems: "center",
                  marginTop: 3,
                }}
              >
                {trayStepCompleted && (
                  <LoadingButton
                    variant="contained"
                    fullWidth={isFullWidth}
                    type="submit"
                    onClick={handleNext}
                  >
                    Continue
                  </LoadingButton>
                )}
                {!fullGrid && (
                  <Button color="inherit" onClick={handleSkip} sx={{ mr: 1 }}>
                    Skip
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default TrayCreateInWizardForm;
